var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    stroke: "currentColor",
    strokeWidth: 2,
    style: {
      fillOpacity: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.829 26.76h-4.24l-1.8401 10.36c-0.3199 1.88-0.1199 3.04 2.0401 3.04h2.2l-0.48 2.84h-2.84c-3.76 0-4.96-1.68-4.32-5.48l1.92-10.76h-2.24l0.48-2.68h2.2l0.84-4.68h3.32l-0.84 4.68h4.28l-0.48 2.68zm6.089-6.76c-1.08 0-1.64-0.52-1.64-1.4 0-1.48 0.92-2.4 2.32-2.4 1.08 0 1.6 0.48 1.6 1.36 0 1.48-0.88 2.44-2.28 2.44zm-2.4 23h-3.28l3.32-18.92h3.32l-3.36 18.92zm10.099-3.44 6.88-15.48h3.6l-9.24 18.92h-3.48l-2.32-18.92h3.32l1.24 15.48z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.879741fd.svg";
export { ForwardRef as ReactComponent };